/** A Firestore Timestamp (which has `.toDate()`) or an ISO string, coerced to a plain Date. */
export function asDate(value: unknown): Date {
  return (value as { toDate?: () => Date })?.toDate?.() ?? new Date(String(value));
}

/** Formats a Firestore Timestamp (or anything with a `.toDate()`) or ISO string as a short
 * relative age — "3 min ago", "2 h ago", "5 d ago". Previously duplicated in ActivityFeed.tsx
 * and NotificationBell.tsx; both now import this instead. */
export function relativeTime(value: unknown): string {
  const date = asDate(value);
  const seconds = Math.round((Date.now() - date.getTime()) / 1000);
  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)} min ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} h ago`;
  return `${Math.floor(seconds / 86400)} d ago`;
}
